import React from "react";

import { Row, Col, Input, Pagination, Card } from "antd";
import { Margin } from "styled-components-spacing";
import Center from "react-center";
import { PlusOutlined } from "@ant-design/icons";
import LazyLoad from "react-lazyload";

// CSS Files
import "../../../Fonts/Fonts.css";
import "../../../Statics/Common/FontStyle.css";
import "../../../Statics/InsuranceKnowledge/Approvals/Approvals.css";

const booksCard = {
  borderRadius: "20px",
  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
  backgroundColor: "#fff",
  opacity: "95%",
};
const bookCard = {
  borderRadius: "10px",
  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
  margin: "15px",
  backgroundColor: "#fff",
};

const BooksCard = (props) => {
  return props.size === "laptopdesktop" ? (
    <div>
      <div style={booksCard}>
        <Row>
          <Col span={24}>
            <Center>
              <Margin top={3}>
                <div>
                  <p className="cardTitle">
                    <strong>کتاب ها</strong>
                  </p>
                </div>
              </Margin>
            </Center>
            <Center>
              <hr className="cardTitleHR" />
            </Center>
            <Margin top={3}></Margin>
            <Row>
              <Col span={24}>
                <Row>
                  <Col span={2}></Col>
                  {props.books.map((item, index) => {
                    return [
                      <Col span={5} key={index}>
                        <a
                          onClick={() =>
                            props.history.push(`/booksinside/${item.id}`)
                          }
                        >
                          <Card style={bookCard}>
                            <LazyLoad>
                              <Center>
                                <img
                                  style={{ width: "100%" }}
                                  src={item.image}
                                />
                              </Center>
                            </LazyLoad>
                          </Card>
                          <Center>
                            <p className="textParagraphTablet">{item.title}</p>
                          </Center>
                        </a>
                      </Col>,
                    ];
                  })}

                  <Col span={2}></Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col span={1}></Col>
          <Col span={23} style={{ direction: "ltr", textAlign: "left" }}>
            <Margin bottom={3}>
              <a
                onClick={() => props.history.push("/booksAll")}
                style={{
                  fontSize: ".75em",
                  fontFamily: "IRANSans",
                  paddingRight: "20px",
                  color: "#ed1c24",
                }}
              >
                <div style={{ display: "inline" }}>
                  <PlusOutlined />
                </div>{" "}
                <strong>مشاهده تمامی کتاب ها</strong>
              </a>
            </Margin>
          </Col>
        </Row>
      </div>
    </div>
  ) : props.size === "tablet" ? (
    <div style={booksCard}>
      <Row>
        <Col span={24}>
          <Center>
            <Margin top={3}>
              <div>
                <p className="cardTitleTablet">
                  <strong>کتاب ها</strong>
                </p>
              </div>
            </Margin>
          </Center>
          <Center>
            <hr className="cardTitleHRTablet" />
          </Center>
          <Row>
            <Col span={24}>
              <Row>
                {props.books.map((item, index) => {
                  return [
                    <Col span={8} key={index}>
                      <a
                        onClick={() =>
                          props.history.push(`/booksinside/${item.id}`)
                        }
                      >
                        <Card style={bookCard}>
                          <LazyLoad>
                            <Center>
                              <img style={{ width: "100%" }} src={item.image} />
                            </Center>
                          </LazyLoad>
                        </Card>
                        <Center>
                          <p className="textParagraph">{item.title}</p>
                        </Center>
                      </a>
                    </Col>,
                  ];
                })}
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col span={1}></Col>
        <Col span={23} style={{ direction: "ltr", textAlign: "left" }}>
          <Margin bottom={3}>
            <a
              onClick={() => props.history.push("/booksAll")}
              style={{
                fontSize: ".8em",
                fontFamily: "IRANSans",
                paddingRight: "20px",
                color: "#ed1c24",
              }}
            >
              <div style={{ display: "inline" }}>
                <PlusOutlined />
              </div>{" "}
              <strong>مشاهده تمامی کتاب ها</strong>
            </a>
          </Margin>
        </Col>
      </Row>
    </div>
  ) : (
    <div style={booksCard}>
      <Row>
        <Col span={24}>
          <Center>
            <Margin top={3}>
              <div>
                <p className="cardTitleMobile">
                  <strong>کتاب ها</strong>
                </p>
              </div>
            </Margin>
          </Center>
          <Center>
            <div className="cardTitleHR"></div>
          </Center>
          <Row>
            <Col span={24}>
              <Row>
                {props.books.map((item, index) => {
                  return [
                    <Col span={24} key={index}>
                      <a
                        onClick={() =>
                          props.history.push(`/booksinside/${item.id}`)
                        }
                      >
                        <Card style={bookCard}>
                          <LazyLoad>
                            <Center>
                              <img style={{ width: "100%" }} src={item.image} />
                            </Center>
                          </LazyLoad>
                        </Card>
                        <Center>
                          <p className="textParagraphMobile">{item.title}</p>
                        </Center>
                      </a>
                    </Col>,
                  ];
                })}
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col span={1}></Col>
        <Col span={23} style={{ direction: "ltr", textAlign: "left" }}>
          <Margin bottom={3}>
            <a
              onClick={() => props.history.push("/booksAll")}
              style={{
                fontSize: ".7em",
                fontFamily: "IRANSans",
                paddingRight: "20px",
                color: "#ed1c24",
              }}
            >
              <div style={{ display: "inline" }}>
                <PlusOutlined />
              </div>{" "}
              <strong>مشاهده تمامی کتاب ها</strong>
            </a>
          </Margin>
        </Col>
      </Row>
    </div>
  );
};

export default BooksCard;
